"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/BackButton.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _icons = require('./icons');






// The chevron at the card's top-left corner.
const BackButton = ({ onClick, label = 'Back' }) => (
  _react2.default.createElement('button', {
    type: "button",
    className: "auth-back",
    'aria-label': label,
    onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}

    , _react2.default.createElement(_icons.ChevronLeftIcon, { size: 22, __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} )
  )
)

exports. default = BackButton
